export default "__VITE_ASSET__BjRLteDh__"